import Vue from 'vue';
import Router from 'vue-router';
// import ActivateUser from './components/Account/User/ActivateUser.vue';
// import RegisterUser from './components/Account/User/RegisterUser.vue';
// import SigninUser from './components/Account/User/SigninUser.vue';
// import Dashboard from './components/Dashboard.vue';
// import Privacy from './components/Privacy.vue';
// import Terms from './components/Terms.vue';
import UpdateAlert from './graphql/UpdateAlert.gql';
import UpdateErrors from './graphql/UpdateErrors.gql';
// import Account from './layouts/Account.vue';
// import Home from './layouts/Home.vue';
import HomePlaceholder from './layouts/HomePlaceholder.vue';
import NotFound from './layouts/NotFound.vue';
import { apolloProvider } from './vue-apollo';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
    path: '/',
    name: 'home-placeholder',
    component: HomePlaceholder
  },{
    path: '*',
    name: 'notFound',
    component: NotFound
  }]
  // routes: [{
  //   path: '/',
  //   component: Home,
  //   children: [{
  //     path: '',
  //     name: 'home',
  //     component: Dashboard,
  //   },{
  //     path: '/terms',
  //     name: 'terms',
  //     component: Terms
  //   },{
  //     path: '/privacy',
  //     name: 'privacy',
  //     component: Privacy
  //   }]
  // },{
  //   path: '/',
  //   component: Account,
  //   children: [{
  //     path: '/activate/:id',
  //     name: 'activate',
  //     component: ActivateUser,
  //     props: (route) => ({
  //       id: route.params.id,
  //       reference: route.query.reference
  //     }),
  //     meta: { access: 'guest' }
  //   },{
  //     path: '/register',
  //     name: 'register',
  //     component: RegisterUser,
  //     props: (route) => ({ reference: route.query.reference }),
  //     meta: { access: 'guest' }
  //   },{
  //     path: '/signin',
  //     name: 'signin',
  //     component: SigninUser,
  //     props: (route) => ({ reference: route.query.reference }),
  //     meta: { access: 'guest' }
  //   }]
  // },{
  //   path: '*',
  //   name: 'notFound',
  //   component: NotFound
  // }]
});

router.beforeEach((to, from, next) => {
  let apolloClient = apolloProvider.defaultClient;
  apolloClient.mutate({
    mutation: UpdateAlert,
    variables: {
      message: '',
      variant: 'success',
      show: false
    }
  });

  apolloClient.mutate({
    mutation: UpdateErrors,
    variables: {
      input: []
    }
  });

  let token = JSON.parse(localStorage.getItem('auth-token'));
  if (to.matched.some(record => record.meta.access === 'user')) {
    if (token === null) {
      next({ name: 'signin' });
    }
  } else if (to.matched.some(record => record.meta.access === 'guest')) {
    if (token !== null) {
      next({ name: 'home' });
    }
  }
  next();
})

export default router;
